export const PDFium = {
    Module: null,
    FPDF: {},

    wasm: null,
    wasmBuffer: null,
    total: null,
    UTF16Decoder: typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined,

    I8: Int8Array,
    I16: Int16Array,
    I32: Int32Array,
    U8: Uint8Array,
    CH: Uint8Array,
    U16: Uint16Array,
    U32: Uint32Array,
    F32: Float32Array,
    F64: Float64Array,

    C: 4,

    option: {
        MIN_FONT_SIZE: 7,
        WIDE_CHAR_SIZE: 2,
        PRE_TEXT_LENGTH: 30,
        NEAR_TEXT_LENGTH: 30,
        TEXT_SELECTION_GAP: 20,
    },

    init() {
        let self = this;

        // pdfium initialization
        Object.assign(self.FPDF, {
            ANNOT: 0x01, // Set if annotations are to be rendered.
            LCD_TEXT: 0x02, // Set if using text rendering optimized for LCD display.
            NO_NATIVETEXT: 0x04, // Don't use the native text output available on some platforms
            GRAYSCALE: 0x08, // Grayscale output.
            DEBUG_INFO: 0x80, // Set if you want to get some debug info. Please discuss with Foxit first if you need to collect debug info.
            NO_CATCH: 0x100, // Set if you don't want to catch exception.
            RENDER_LIMITEDIMAGECACHE: 0x200, // Limit image cache size.
            RENDER_FORCEHALFTONE: 0x400, // Always use halftone for image stretching.
            PRINTING: 0x800, // Render for printing.
            REVERSE_BYTE_ORDER: 0x10, // Set whether render in a reverse Byte order, this flag only.
            Bitmap_Gray: 1,
            Bitmap_BGR: 2,
            Bitmap_BGRx: 3,
            Bitmap_BGRA: 4,
            LAST_ERROR: { // Last error types
                SUCCESS: 0,
                UNKNOWN: 1,
                FILE: 2,
                FORMAT: 3,
                PASSWORD: 4,
                SECURITY: 5,
                PAGE: 6
            }
        });

        self.F = self.FPDF.Bitmap_BGRA;

        self.initFPDF();

        // init library
        console.log('Initializing library...');
        self.FPDF.Init();

        return true;
    },

    initFPDF() {
        let Module = this.Module;
        let FPDF = this.FPDF;

        FPDF.Init = Module.cwrap('PDFium_Init');
        // FPDF.Init = Module.cwrap('FPDF_InitLibrary');
        FPDF.RenderPageBitmap = Module.cwrap('FPDF_RenderPageBitmap', '', ['number', 'number', 'number', 'number', 'number', 'number', 'number', 'number']);
        FPDF.Page_GetThumbnailAsBitmap = Module.cwrap('FPDFPage_GetThumbnailAsBitmap', 'number', ['number']);

        FPDF.Bitmap_GetWidth = Module.cwrap('FPDFBitmap_GetWidth', 'number', ['number']);
        FPDF.Bitmap_GetHeight = Module.cwrap(' FPDFBitmap_GetHeight', 'number', ['number']);

        FPDF.Bitmap_FillRect = Module.cwrap('FPDFBitmap_FillRect', '', ['number', 'number', 'number', 'number', 'number', 'number']);
        FPDF.Bitmap_CreateEx = Module.cwrap('FPDFBitmap_CreateEx', 'number', ['number', 'number', 'number', 'number', 'number']);
        FPDF.Bitmap_Destroy = Module.cwrap('FPDFBitmap_Destroy', '', ['number']);

        FPDF.Text_LoadPage = Module.cwrap('FPDFText_LoadPage', 'number', ['number']);
        FPDF.Text_ClosePage = Module.cwrap('FPDFText_ClosePage', '', ['number']);
        FPDF.Text_GetMatrix = Module.cwrap('FPDFText_GetMatrix', 'number', ['number', 'number', 'number']);

        FPDF.Text_FindStart = Module.cwrap('FPDFText_FindStart', 'number', ['number', 'number', 'number', 'number']);
        FPDF.Text_FindNext = Module.cwrap('FPDFText_FindNext', 'number', ['number']);
        FPDF.Text_GetSchResultIndex = Module.cwrap('FPDFText_GetSchResultIndex', 'number', ['number']);
        FPDF.Text_GetText = Module.cwrap('FPDFText_GetText', 'number', ['number', 'number', 'number', 'number']);
        FPDF.Text_FindClose = Module.cwrap('FPDFText_FindClose', '', ['number']);

        FPDF.Text_GetFontWeight = Module.cwrap('FPDFText_GetFontWeight', 'number', ['number', 'number']);
        FPDF.Text_GetFontSize = Module.cwrap('FPDFText_GetFontSize', 'number', ['number', 'number']);

        FPDF.Text_GetCharIndexAtPos = Module.cwrap('FPDFText_GetCharIndexAtPos', 'number', ['number', 'number', 'number', 'number', 'number']);
        FPDF.Text_GetCharAngle = Module.cwrap('FPDFText_GetCharAngle', 'number', ['number', 'number']);
        FPDF.Text_GetTextIndexFromCharIndex = Module.cwrap('FPDFText_GetTextIndexFromCharIndex', 'number', ['number', 'number']);

        FPDF.Page_CountObjects = Module.cwrap('FPDFPage_CountObjects', 'number', ['number']);
        FPDF.Page_GetObject = Module.cwrap('FPDFPage_GetObject', 'number', ['number', 'number']);

        FPDF.PageToDevice = Module.cwrap('FPDF_PageToDevice', 'number', ['number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number']);

        FPDF.PageObj_GetType = Module.cwrap('FPDFPageObj_GetType', 'number', ['number']);
        FPDF.PageObj_GetBounds = Module.cwrap('FPDFPageObj_GetBounds', 'number', ['number', 'number', 'number', 'number', 'number']);
        FPDF.PageObj_GetMatrix = Module.cwrap('FPDFPageObj_GetMatrix', 'number', ['number', 'number']);

        FPDF.FormObj_CountObjects = Module.cwrap('FPDFFormObj_CountObjects', 'number', ['number']);
        FPDF.FormObj_GetObject = Module.cwrap('FPDFFormObj_GetObject', 'number', ['number', 'number']);

        FPDF.TextObj_GetText = Module.cwrap('FPDFTextObj_GetText', 'number', ['number', 'number', 'number', 'number']);
        FPDF.TextObj_GetFont = Module.cwrap('FPDFTextObj_GetFont', 'number', ['number']);

        FPDF.Font_GetFontName = Module.cwrap('FPDFFont_GetFontName', 'number', ['number', 'number', 'number']);

        FPDF.LoadPage = Module.cwrap('FPDF_LoadPage', 'number', ['number', 'number']);
        FPDF.ClosePage = Module.cwrap('FPDF_ClosePage', '', ['number']);

        FPDF.LoadMemDocument = Module.cwrap('FPDF_LoadMemDocument', 'number', ['number', 'number', 'string']);
        FPDF.GetPageSizeByIndex = Module.cwrap('FPDF_GetPageSizeByIndex', 'number', ['number', 'number', 'number', 'number']);
        FPDF.GetPageLabel = Module.cwrap('FPDF_GetPageLabel', 'number', ['number', 'number', 'number', 'number']);

        FPDF.GetLastError = Module.cwrap('FPDF_GetLastError', 'number');
        FPDF.GetPageCount = Module.cwrap('FPDF_GetPageCount', 'number', ['number']);
        FPDF.CloseDocument = Module.cwrap('FPDF_CloseDocument', '', ['number']);
        FPDF.DestroyLibrary = Module.cwrap('FPDF_DestroyLibrary');
    },

    heap(J, s) {
        let self = this;
        let Module = this.Module;

        let E;
        switch (J) {
            case self.I8:
                E = Module.HEAP8;
                break;
            case self.I16:
                E = Module.HEAP16;
                break;
            case self.I32:
                E = Module.HEAP32;
                break;
            case self.U8:
                E = Module.HEAPU8;
                break;
            case self.U16:
                E = Module.HEAPU16;
                break;
            case self.U32:
                E = Module.HEAPU32;
                break;
            case self.F32:
                E = Module.HEAPF32;
                break;
            case self.F64:
                E = Module.HEAPF64;
                break;
        }
        const Z = J.BYTES_PER_ELEMENT;
        const m = Module._malloc(s * Z);
        const a = Array(1 + s);
        a[0] = ({s, J, Z, E, m, free: () => Module._free(m)});
        for (let i = 0; i < s; i++) a[i + 1] = ({
            p: m + (i * Z), get v() {
                return E[m / Z + i];
            }
        });
        return a;
    },

    H(t, s, d) {
        let self = this;
        return f => {
            const [m, ...a] = self.heap(t, s);
            const v = f(...a.map(x => x.p));

            if (!v) {
                m.free();
                return d;
            }

            const r = a.map(x => x.v);
            m.free();
            return r;
        };
    },

    pageSize(page) {
        let self = this;
        let w = NaN;
        let h = NaN;
        let reloadCount = 5;

        for (let i = 0; (isNaN(w) || isNaN(h)) && (i < reloadCount);++i) {
            [w, h] = self.H(self.F64, 2, [-1, -1])((w, h) => {
                return self.FPDF.GetPageSizeByIndex(self.wasm, page, w, h);
            }).map(v => parseFloat(v));
        }

        return [w, h];
    },

    pageObjBounds(obj) {
        let self = this;
        return self.H(self.F32, 4, [-1, -1, -1, -1])((l, b, r, t) => {
            return self.FPDF.PageObj_GetBounds(obj, l, b, r, t);
        }).map(v => parseFloat(v));
    },

    pageObjMatrix(obj) {
        let self = this;
        return self.H(self.F32, 6, [-1, -1, -1, -1, -1, -1])((a) => {
            return self.FPDF.PageObj_GetMatrix(obj, a);
        }).map(v => parseFloat(v));
    },

    textMatrix(obj, index) {
        let self = this;
        return self.H(self.F32, 6, [-1, -1, -1, -1, -1, -1])((a) => {
            return self.FPDF.Text_GetMatrix(obj, index, a);
        }).map(v => parseFloat(v));
    },

    pageToDevice(page, width, height, left, top) {
        let self = this;
        let w = parseInt(width),
            h = parseInt(height),
            l = parseInt(left),
            t = parseInt(top);

        return self.H(self.I32, 2, [-1, -1])((x, y) => {
            return self.FPDF.PageToDevice(page, 0, 0, w, h, 0, l, t, x, y);
        }).map(v => parseInt(v));
    },

    fontName(text_obj) {
        let self = this;
        let FPDF = this.FPDF;
        let Module = this.Module;

        const font = FPDF.TextObj_GetFont(text_obj);
        let size = FPDF.Font_GetFontName(font, 0, 0);

        let buffer = Module._malloc(size);
        let size2 = FPDF.Font_GetFontName(font, buffer, size);
        if (size !== size2) {
            console.error("Font_GetFontName error!")
        }
        let fontName = UTF8Decoder.decode(Module.HEAPU8.subarray(buffer, buffer + size));
        Module._free(buffer)

        return fontName;
    },

    pageLabel(page) {
        let self = this;
        let FPDF = this.FPDF;
        let Module = this.Module;

        let size = FPDF.GetPageLabel(self.wasm, page, 0, 0);

        let buffer = Module._malloc(size);
        let size2 = FPDF.GetPageLabel(self.wasm, page, buffer, size);
        if (size !== size2) {
          console.error("GetPageLabel error!")
        }

        let pageLabel = this.UTF16Decoder.decode(Module.HEAPU8.subarray(buffer, buffer + (size - 2)));
        Module._free(buffer)

        return pageLabel;
    },

    makeText(page, obj, tpage, zoomRate, width, height) {
        let self = this;
        let FPDF = this.FPDF;
        let Module = this.Module;

        let [left, bottom, right, top] = self.pageObjBounds(obj);
        let cindex = FPDF.Text_GetCharIndexAtPos(tpage, left, top, right - left, top - bottom);
        let angle = FPDF.Text_GetCharAngle(tpage, cindex);
        cindex = FPDF.Text_GetTextIndexFromCharIndex(tpage, cindex);
        if (cindex < 0 || top - bottom === 0) {
            return ["", ""];
        }

        let a = self.pageObjMatrix(obj);

        let fontSize = FPDF.Text_GetFontSize(tpage, cindex);
        if (fontSize === 1) {
            fontSize = a[3] * zoomRate;
        }
        else {
            fontSize = fontSize * a[3] * zoomRate;
        }

        if (self.option.MIN_FONT_SIZE > fontSize) {
            return ["", ""];
        }

        let size = FPDF.TextObj_GetText(obj, tpage, 0, 0);
        let [device_left, device_bottom] = self.pageToDevice(page, width, height, left, bottom);
        let [device_right, device_top] = self.pageToDevice(page, width, height, right, top);

        let textBuffer = Module._malloc(size);
        let size2 = FPDF.TextObj_GetText(obj, tpage, textBuffer, size);

        if (size !== size2) {
            console.error("TextObj_GetText error!")
        }

        let text = this.UTF16Decoder.decode(Module.HEAPU8.subarray(textBuffer, textBuffer + size));
        let zeroIndex = text.indexOf('\0');
        if (-1 < zeroIndex) {
            text = text.substring(0, zeroIndex);
        }

        Module._free(textBuffer)

        let twidth = (device_right * zoomRate) - (device_left * zoomRate);
        let theight = Math.abs((device_top * zoomRate) - (device_bottom * zoomRate));
        let weight = 400;
        if (cindex >= 0) {
            weight = FPDF.Text_GetFontWeight(tpage, cindex);
        }

        if (0 != a[1]) {
            let skewX = Math.atan2(a[2], a[0]) * 180 / Math.PI / -1;
            let skewY = Math.atan2(a[1], a[3]) * 180 / Math.PI / -1;
            let [tx, ty] = self.pageToDevice(page, width, height, a[4], a[5]);

            return [`
                <span>
                    <span data-tx="${tx * zoomRate - self.option.TEXT_SELECTION_GAP}" data-ty="${ty * zoomRate}" style=" height: 100vh; width: 100vw; position: absolute; left:${tx * zoomRate - self.option.TEXT_SELECTION_GAP}px;top:${ty * zoomRate}px; z-index: -1; user-select: none;"></span>
                    <span class='textSpan' data-a="${a[0]}" data-d="${a[3]}" data-tx="${tx * zoomRate}" data-ty="${ty * zoomRate}" data-width="${twidth}" data-height="${theight}" style="position: absolute;left:${tx * zoomRate}px;top:${ty * zoomRate}px;font-size:${fontSize}px;font-family:Arial,sans-serif;transform:skew(${skewX}deg, ${skewY}deg)">${text}</span>
                </span>`,
                text
            ];
        }
        else {
            return [`
                <span>
                    <span style=" height: 100vh; width: 100vw; position: absolute; left:${(device_left * zoomRate) - self.option.TEXT_SELECTION_GAP}px;top:${device_top * zoomRate}px; z-index: -1; user-select: none;"></span>
                    <span class='textSpan' data-width="${twidth}" data-height="${theight}" style="position: absolute;left:${device_left * zoomRate}px;top:${device_top * zoomRate}px;font-size:${fontSize}px;font-family:Arial,sans-serif;">${text}</span>
                </span>`,
                text
            ];
        }
    },

    getFormText(page, obj, tpage, zoomRate, width, height) {
        let self = this;
        let FPDF = this.FPDF;

        let html = "";
        let text = "";
        
        const formCount = FPDF.FormObj_CountObjects(obj);

        let formObj, type;
        for (let i = 0; i < formCount; ++i) {
            formObj = FPDF.FormObj_GetObject(obj, i);
            type = FPDF.PageObj_GetType(formObj);
            if (type === 1) {
                let r = this.makeText(page, formObj, tpage, zoomRate, width, height);
                html += r[0];
                text += r[1];
            }
            else if (type === 5) {
                let r = this.getFormText(page, formObj, tpage, zoomRate, width, height);
                html += r[0];
                text += r[1];
            }
        }
        
        return [html, text];
    },

    setText(page, zoomRate, width, height) {
        let self = this;
        let FPDF = this.FPDF;

        let html = "";
        let text = "";
        
        const textPage  = FPDF.Text_LoadPage(page);
        const objCount = FPDF.Page_CountObjects(page);

        let text_obj, type;
        for (let oindex = 0; oindex < objCount; ++oindex) {
            text_obj = FPDF.Page_GetObject(page, oindex);
            type = FPDF.PageObj_GetType(text_obj);

            if (1 === type) {
                let r = this.makeText(page, text_obj, textPage, zoomRate, width, height);
                html += r[0];
                text += r[1];
            }
            else if (5 === type) {
                let r = this.getFormText(page, text_obj, textPage, zoomRate, width, height);
                html += r[0];
                text += r[1];
            }
        }

        FPDF.Text_ClosePage(textPage);
        
        return [html, text];
    },

    searchText(keyword, start = 0, end) {
        let self = this;
        let FPDF = this.FPDF;
        let Module = this.Module;

        let texts = [];

        if (!keyword) {
            return null;
        }

        if (!end) {
            end = self.pageCount();
        }

        let wcs = self.option.WIDE_CHAR_SIZE;

        let keywordBufferSize = (keyword.length + 1) * wcs;
        let keywordBuffer = Module._malloc(keywordBufferSize);
        for (let i = 0; i < keyword.length; i++) {
            Module.HEAPU8[keywordBuffer + (i * wcs)] = keyword.charCodeAt(i);
            Module.HEAPU8[keywordBuffer + (i * wcs + 1)] = keyword.charCodeAt(i) >> 8;
        }
        Module.HEAPU8[keywordBuffer + keywordBufferSize - 2] = 0;
        Module.HEAPU8[keywordBuffer + keywordBufferSize - 1] = 0;

        let page, textPage, shandle, sindex, def, text_length, pos;
        let buffer, length, text;

        for (let i = start; i < end; ++i) {
            page = FPDF.LoadPage(self.wasm, i);
            textPage  = FPDF.Text_LoadPage(page);

            shandle = FPDF.Text_FindStart(textPage, keywordBuffer, 0, 0);

            while (FPDF.Text_FindNext(shandle)) {
                sindex = FPDF.Text_GetSchResultIndex(shandle);

                text_length = self.option.PRE_TEXT_LENGTH;
                pos = sindex - text_length;
                if (0 > pos) {
                    pos = 0;
                    text_length = sindex;
                }

                def = sindex - pos;

                text_length += keyword.length + self.option.NEAR_TEXT_LENGTH;

                buffer = Module._malloc(text_length * wcs);
                length = FPDF.Text_GetText(textPage, pos, text_length, buffer);
                length -= 1;
                text = this.UTF16Decoder.decode(Module.HEAPU8.subarray(buffer, buffer + (length * wcs)));
                text = text.substring(0, def) + "<mark>" + text.substring(def, def+keyword.length) + "</mark>" + text.substring(def+keyword.length, text.length);
                text = text.replace(/\r?\n|\r/g, "");
                texts.push({
                    "page": i + 1,
                    "text": text,
                });
                Module._free(buffer);
            }

            FPDF.Text_FindClose(shandle);
            FPDF.Text_ClosePage(textPage);
            FPDF.ClosePage(page);
        }

        Module._free(keywordBuffer);

        return texts;
    },

    pageCount() {
        if (!this.total) {
            this.total = this.FPDF.GetPageCount(this.wasm);
        }

        return this.total;
    },

    pageBitmap(page, w, h) {
        let self = this;
        let FPDF = this.FPDF;
        let Module = this.Module;

        let C = self.C;
        let F = self.F;

        const flag = FPDF.REVERSE_BYTE_ORDER | FPDF.ANNOT;
        const heap = Module._malloc(w * h * C);

        const bmap = FPDF.Bitmap_CreateEx(w, h, F, heap, w * C);

        FPDF.Bitmap_FillRect(bmap, 0, 0, w, h, 0xFFFFFFFF);
        FPDF.RenderPageBitmap(bmap, page, 0, 0, w, h, 0, flag);

        let data = [];
        for (let v = 0; v < w * h * C; v++) {
            data.push(Module.HEAPU8[heap + v]);
        }

        Module._free(heap);
        FPDF.Bitmap_Destroy(bmap);

        return data;
    },

    getPageBitmap(i = 0, w, h) {
        let self = this;
        let FPDF = this.FPDF;

        const page = FPDF.LoadPage(self.wasm, i);

        let bitmap = self.pageBitmap(page, w, h);

        FPDF.ClosePage(page);

        return bitmap;
    },

    getPageRender(i = 0, w, h, scale=1.0) {
        let self = this;
        let FPDF = this.FPDF;

        const page = FPDF.LoadPage(self.wasm, i);
        
        let bitmap = self.pageBitmap(page, Math.floor(w * scale), Math.floor(h * scale));
        let [html, text] = self.setText(page, 1, w, h);
        
        FPDF.ClosePage(page);
        
        return [bitmap, html, text];
    },

    async processPDF(fileByteArray) {
        let self = this;
        let FPDF = this.FPDF;
        let Module = this.Module;

        try {
            // check file size
            console.log('Getting file size...');

            let fileSize = fileByteArray.length;
            console.log("File size: " + fileSize + " bytes");

            // load document to memory
            console.log('Loading data to buffer...');

            self.wasmBuffer = Module._malloc(fileSize);
            Module.HEAPU8.set(fileByteArray, self.wasmBuffer);

            // create document
            console.log('Loading document...');
            self.wasm = FPDF.LoadMemDocument(self.wasmBuffer, fileSize, "");

            // check last error
            let lastError = self.lastError();
            console.log("Load document state: " + lastError);
        } catch (error) {
            console.log('Error while process PDF: ' + error.message);
        }
    },

    loadFileFromURL(url) {
        let self = this;

        return fetch(url)
          .then(r => {
              if (!r.ok) {
                  throw new Error(`${r.status} (${r.statusText})`);
              }
              return r.arrayBuffer();
          })
          .then(buffer => {
              let byteArray = new Uint8Array(buffer);

              if (byteArray.length <= 0) {
                  throw new Error('The PDF file is invalid');
              }

              return byteArray;
          })
          .catch (error => console.log('Error while load file from URL: ' + error))
    },

    async closeDoc() {
        let self = this;
        let Module = this.Module;

        self.total = null;
        if (self.wasmBuffer) {
            Module._free(self.wasmBuffer);
        }

        if (self.wasm) {
            self.FPDF.CloseDocument(self.wasm);
        }
    },

    async close() {
        let self = this;
        let Module = this.Module;

        self.total = null;
        if (self.wasmBuffer) {
            Module._free(self.wasmBuffer);
        }

        if (self.wasm) {
            self.FPDF.CloseDocument(self.wasm);
        }

        self.FPDF.DestroyLibrary();
    },

    lastError() {
        let self = this;
        let lastError = self.FPDF.GetLastError();

        switch (lastError) {
            case self.FPDF.LAST_ERROR.SUCCESS:
                return "success";
            case self.FPDF.LAST_ERROR.UNKNOWN:
                return "unknown error";
            case self.FPDF.LAST_ERROR.FILE:
                return "file not found or could not be opened";
            case self.FPDF.LAST_ERROR.FORMAT:
                return "file not in PDF format or corrupted";
            case self.FPDF.LAST_ERROR.PASSWORD:
                return "password required or incorrect password";
            case self.FPDF.LAST_ERROR.SECURITY:
                return "unsupported security scheme";
            case self.FPDF.LAST_ERROR.PAGE:
                return "page not found or content error";
            default:
                return "unknown error";
        }
    },
};
